import React from "react";
import { getLiveConfigUrl } from "../../utils";
import { LIVE_CONFIG_ENV } from "../../hooks/useLiveConfig";
import { setOriginalVideo } from "../../hooks/useVideoApi/liveUtils";
import { VideoDataProvider } from "./VideoDataProvider";
import PropTypes from "prop-types";

export const LiveDataProvider = props => {
  const { config, orcaRef } = props;

  const handleSetOriginalVideoWithLiveConfig = ({
    type,
    videoData,
    dispatchVideoApiEvent,
    videoApiUrl,
    domain
  }) => {
    const { liveConfigEnv = LIVE_CONFIG_ENV } = config;
    const liveConfigUrl = getLiveConfigUrl(liveConfigEnv);

    // This needs access to props that VideoDataProvider doesn't have directly,
    // like the full dispatch function and domain info.
    setOriginalVideo({
      type,
      videoData,
      liveConfigUrl,
      orcaRef,
      dispatchVideoApiEvent,
      videoApiUrl,
      domain
    });
  };

  const useVideoApiOptions = {
    onSetOriginalVideo: handleSetOriginalVideoWithLiveConfig
  };

  return (
    <VideoDataProvider {...props} useVideoApiOptions={useVideoApiOptions} />
  );
};

LiveDataProvider.propTypes = {
  config: PropTypes.object,
  orcaRef: PropTypes.string,
  children: PropTypes.node.isRequired
};
